<script setup lang="ts" generic="Value">
type Option = {
  value: Value;
  label: string;
};

defineProps<{
  modelValue: Value;
  options: Option[];
}>();

defineEmits<{
  'update:modelValue': [value: Value];
}>();
</script>

<template>
  <div class="flex border border-gray-300 rounded-md shadow-sm overflow-hidden">
    <button
      v-for="option in options"
      :key="option.value?.toString()"
      type="button"
      class="p-2 w-24 text-sm"
      :class="{
        'bg-neutral-50 text-gray-900': modelValue !== option.value,
        'bg-blue-500 text-white font-bold': modelValue === option.value,
      }"
      @click="$emit('update:modelValue', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>
